import { render, staticRenderFns } from "./AddFinancialInfo.vue?vue&type=template&id=50032c98&scoped=true&"
import script from "./AddFinancialInfo.vue?vue&type=script&lang=js&"
export * from "./AddFinancialInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddFinancialInfo.vue?vue&type=style&index=0&id=50032c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50032c98",
  null
  
)

export default component.exports